module.exports = __webpack_public_path__ + "img/code.5ed70608.png";